import { Outlet } from "react-router-dom";
import FloatNav from "../Layout/FloatNav";
import Header from "./Header/index";
import Contexts from "../../contexts/Contexts";
import { useContext } from "react";
import Footer from "../Layout/Footer";
import RightSide from "../Layout/RightSide";

const EmptyLayout = ({
  sideBar = false,
  showFilter = false,
}: {
  sideBar?: boolean;
  showFilter?: boolean;
}) => {
  const { screenSize } = useContext(Contexts);

  return screenSize.isDesktop ? (
    // PC端：保持完整布局（Header + 内容 + Footer）
    <div>
      <Header showFilter={showFilter} />
      <main className="main-content">
        <FloatNav />
        <div className="pc-main-content">
          <Outlet />
        </div>
        {sideBar && <RightSide />}
      </main>
      <Footer />
    </div>
  ) : (
    // 移动端：只显示内容区域，不包含Header和Footer
    <div>
      <Outlet />
    </div>
  );
};

export default EmptyLayout;
